module.exports = __webpack_public_path__ + "img/view_messages_icon.92493198.png";